import React from 'react';
import '../svg.css';


const Interiors_Signage = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="interiors_signage-1" width="36" height="36" rx="10" /></g><path className="interiors_signage-2" d="M19.89,25.33H18.73V11.89a1.44,1.44,0,1,0-1.46,0V25.33H16.11a.73.73,0,1,0,0,1.46h3.78a.73.73,0,1,0,0-1.46Z" /><path className="interiors_signage-3" d="M16.34,13.05h-5.4a.36.36,0,0,0-.28.12L9.32,14.53a.4.4,0,0,0-.12.29.37.37,0,0,0,.13.28l1.33,1.22a.38.38,0,0,0,.27.1h5.41V13.05Z" /><path className="interiors_signage-3" d="M26.69,18.46l-1.35-1.37a.39.39,0,0,0-.28-.11H19.67v3.37h5.4a.43.43,0,0,0,.27-.1L26.67,19a.39.39,0,0,0,.13-.28A.42.42,0,0,0,26.69,18.46Z" />        </svg>
    );
};

export default Interiors_Signage;
